    <rask-leverantorsorderrad-edit
        [enableCommands]="enableCommands"
        [twoRowMode]="true"
        [rootForm]="rootForm"
        [order]="order"
        [leverantorsorderrad]="model">
    </rask-leverantorsorderrad-edit>
